<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-5">Zmień hasło</h1>
      <LoginAlerts
        :show="message.show"
        :type="message.color"
        :msg="message.msg"
        @close="message.show = false"
        dismissible
      />
      <v-form name="change-password2" @submit.prevent>
        <validation-observer ref="observer" v-slot="{}">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email"
            name="e-mail"
          >
            <v-text-field
              v-model="email"
              label="Adres e-mail"
              :error-messages="errors"
              required
              placeholder="Wpisz Adres e-mail"
              outlined
              persistent-placeholder
              name="email"
              autocomplete="off"
              class="mb-1"
            />
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            name="Stare hasło"
          >
            <v-text-field
              v-model="oldPassword"
              :append-icon="e1 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (e1 = !e1)"
              :type="e1 ? 'password' : 'text'"
              label="Stare hasło"
              :error-messages="errors"
              placeholder="Wpisz stare hasło"
              outlined
              persistent-placeholder
              class="mb-1"
            />
          </ValidationProvider>

          <ValidationProvider
            v-slot="{ errors }"
            :rules="passwordRules"
            name="Nowe hasło"
          >
            <v-text-field
              v-model="password"
              :append-icon="e2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (e2 = !e2)"
              :type="e2 ? 'password' : 'text'"
              label="Nowe hasło"
              :error-messages="errors"
              placeholder="Wpisz nowe hasło"
              outlined
              persistent-placeholder
              autocomplete="new-password"
              class="mb-1"
              name="password"
            />
          </ValidationProvider>

          <ValidationProvider
            name="Powtórz hasło"
            rules="required"
            v-slot="{ failed }"
          >
            <v-text-field
              v-model="repeatPassword"
              :append-icon="e3 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="() => (e3 = !e3)"
              :type="e3 ? 'password' : 'text'"
              label="Powtórz nowe hasło"
              :error="failed"
              placeholder="Powtórz nowe hasło"
              outlined
              persistent-placeholder
              autocomplete="new-password"
              class="mb-1"
              name="repeatPassword"
            />
          </ValidationProvider>

          <div class="actions">
            <LibBtnSimple
              color="primary"
              underline
              rounded
              text="Zaloguj się"
              :to="{ name: 'Login' }"
            />
            <v-btn
              rounded
              large
              color="primary"
              elevation="0"
              class="ml-2"
              @click="resetPassword"
              title="Zmień hasło"
            >
              Zmień hasło
            </v-btn>
          </div>
        </validation-observer>
      </v-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import LoginAlerts from "../components/LoginAlerts.vue";
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";

import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required, regex, oneOf } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
setInteractionMode("lazy");
extend("required", required);
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Hasła muszą być identyczne"
});

export default {
  name: "ChangingExpiredPassword",
  components: {
    ValidationObserver,
    ValidationProvider,
    LoginAlerts,
    LibBtnSimple
  },
  props: {
    h: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      email: null,
      oldPassword: null,
      password: "",
      repeatPassword: "",
      e1: true,
      e2: true,
      e3: true,
      error: null,
      passwordRulesBase: {
        required: true,
        password: { target: "@Powtórz hasło" }
      },
      message: {
        show: false,
        color: "error",
        msg: "",
        timeout: 0,
        closeAction: () => {}
      }
    };
  },
  computed: {
    passwordRules() {
      let param = this.$store.getters["conf/getConfigurationParam"](
        "password.strength"
      );
      if (param) {
        extend("regex", {
          ...regex,
          message: param.description,
        });
        return Object.assign({}, this.passwordRulesBase, {
          regex: param.value,
        });
      }
      return this.passwordRulesBase;
    }
  },

  methods: {
    resetPassword() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          axios
            .post(
              `${process.env.VUE_APP_AUTH_REST_URL}/password/expire/change`,
              {
                oldPassword: this.oldPassword,
                newPassword: this.password,
                email: this.email
              }
            )
            .then(({ data }) => {
              if (data.success) {
                this.message.msg = "Hasło zostało zmienione";
                this.message.color = "success";
                this.message.show = true;
                this.message.closeAction = () => {
                  window.location.replace("/");
                };
              } else {
                this.message.msg = data.errorMessage;
                this.message.color = "error";
                this.message.show = true;
                this.message.closeAction = () => {
                  this.message.show = false;
                };
              }
            })
            .catch((err) => {
              this.message.msg = "Błąd zmiany hasła. Spróbuj później.";
              this.message.color = "error";
              this.message.show = true;
              this.message.closeAction = () => {
                this.message.show = false;
              };
            });
        }
      });
    }
  },
  created() {
    this.$store.dispatch("conf/load", ["password.strength"]);
  },
  metaInfo: {
    title: "Zmiana hasła"
  }
};
</script>
